<template>
  <v-app id="inspire">
    <v-main>
      <transition mode="out-in" enter-active-class="animate__animated animate__fadeIn"
        leave-active-class="animate__animated animate__fadeOut">
        <router-view></router-view>
      </transition>
    </v-main>
  </v-app>
</template>

<script>
export default {};
</script>


<style>
.animate__animated.animate__fadeIn,
.animate__animated.animate__fadeOut {
  --animate-duration: 200ms;
  --animate-delay: 10ms;
}


:root {
  --white: #fff;
  --black: #3e3e3e;
  --deep-blue: #1b3c87;
  --light-blue: #46dbc9;
  --grey: #7d7d7d;
  --yellow: #f8c822;
  /* #eecb55 */
  --red: #fb5d64;
  --pink: #f50057;
  --primary: #eaf0ff;
  --purple: #5d67cf;
  /* --purple:#2d3799; */
  --purple-dark: #2d3799;
  --primary: var(--purple);
  --red-90: hsl(357, 95%, 90%);
  --purple-90: hsl(235, 57%, 90%);
  --yellow-90: hsl(46, 82%, 90%);
  --pink-90: #ec407a;
  --deep-blue-90: hsl(222, 67%, 90%);

  --margin-top: 7.5vh;
  --margin-bottom: 7.5vh;
  --margin: 7.5rem 0;
}

html,
body {
  font-family: "Fira Sans", sans-serif;
  font-family: "Poppins", sans-serif;
  font-family: "Raleway", sans-serif;
  overflow-x: hidden;
  box-sizing: border-box;
  scroll-behavior: smooth;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  text-transform: capitalize;
  font-family: poppins;
}

#inspire {
  min-height: 100vh;
  position: relative;
}

.view {
  padding: 4.5rem 1.75rem 0 !important;
}

.truncate {
  /*truncate long text show them off as ellipses*/
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 80%;
}

.sub-hero-text {
  /* show sub hero text, 
  * typically text after h1, h2,
  * and h3 in grey color */
  color: var(--grey);
  line-height: 26px;
  margin: 0.35rem 0;
}

.grey-text {
  color: var(--grey);
}

.purple-text {
  color: var(--purple);
}

small,
small.small-text {
  font-size: 85%;
}

.text-normal {
  text-transform: unset;
}
</style>